import "assets/css/app.css";
import { Routes, Route } from "react-router-dom";

import HomePage from "pages/HomePage";
import Details from "pages/Details";
import Cart from "pages/Cart";
import Congratulations from "pages/Congratulations";
import NotFound from "pages/NotFound";
import Provider from "helpers/hooks/useGlobalContext";

function App() {
  return (
    <Provider>
      <Routes>
        <Route exact path="/" element={<HomePage />}></Route>
        <Route
          path="/categories/:idc/products/:idp"
          element={<Details />}
        ></Route>
        <Route path="/cart" element={<Cart />}></Route>
        <Route path="/congratulations" element={<Congratulations />}></Route>
        <Route path="*" element={<NotFound />}></Route>
      </Routes>
    </Provider>
  );
}

export default App;
